module.exports = __webpack_public_path__ + "img/zeigling1.0ad4486d.jpg";